import { orchestrator } from 'satcheljs';
import { onAssetsLoaded } from 'owa-timestream-store';
import { getAssetDescriptor } from 'owa-timestream-asset-sdk';

orchestrator(onAssetsLoaded, ({ outlookSpaceAssets }) => {
    const assetsGroupedByType = {};
    outlookSpaceAssets.forEach(asset => {
        if (assetsGroupedByType[asset.type]) {
            assetsGroupedByType[asset.type].push(asset);
        } else {
            assetsGroupedByType[asset.type] = [asset];
        }
    });

    for (const [type, assets] of Object.entries(assetsGroupedByType)) {
        const assetDescriptor = getAssetDescriptor(type);
        if (assetDescriptor?.onProjectOpened) {
            assetDescriptor.onProjectOpened(assets);
        }
    }
});
